module.exports = __webpack_public_path__ + "static/media/header-logo.736f6a39.png";